import { IkpiModalTableStructure } from '@component/Modules/Kpi/Modal'

export const ruptureKpiModalTableStructure: IkpiModalTableStructure[] = [
  {
    group: 'Periodo',
    columns: [
      {
        name: 'Data',
        id: 'periodo-data',
        show: true
      }
    ]
  },
  {
    group: 'Empresa',
    columns: [
      {
        name: 'Código',
        id: 'empresa-codigo-id',
        show: true
      },
      {
        name: 'Nome',
        id: 'empresa-nome-id',
        show: true
      }
    ]
  },
  {
    group: 'Centro',
    columns: [
      {
        name: 'Código',
        id: 'cd-loja-codigo-id',
        show: true
      },
      {
        name: 'Nome',
        id: 'cd-loja-nome-id',
        show: true
      }
    ]
  },
  {
    group: 'Gerente',
    columns: [
      {
        name: 'Categoria',
        id: 'gerente-categoria-id',
        show: true
      },
      {
        name: 'Produto',
        id: 'gerente-produto-id',
        show: true
      }
    ]
  },
  {
    group: 'Produto',
    columns: [
      {
        name: 'Código',
        id: 'produto-codigo-id',
        show: true
      },
      {
        name: 'Material',
        id: 'produto-material-id',
        show: true
      }
    ]
  },
  {
    group: 'Curva',
    columns: [
      {
        name: 'Nome',
        id: 'curva-nome-id',
        show: true
      }
    ]
  },
  {
    group: 'Status',
    columns: [
      {
        name: 'Nome',
        id: 'status-nome-id',
        show: true
      }
    ]
  },
  // {
  //   group: 'Mundo',
  //   columns: [
  //     {
  //       name: 'Nome',
  //       id: 'mundo-nome-id',
  //       show: true
  //     }
  //   ]
  // },
  {
    group: 'Categoria Compacta',
    columns: [
      {
        name: 'Nome',
        id: 'categiria-compacta-nome-id',
        show: true
      }
    ]
  },
  {
    group: 'Categoria',
    columns: [
      {
        name: 'Nome',
        id: 'categiria-nome-id',
        show: true
      }
    ]
  },
  {
    group: 'Sub Categoria',
    columns: [
      {
        name: 'Nome',
        id: 'subcategoria-nome-id',
        show: true
      }
    ]
  },
  {
    group: 'Fornecedor',
    columns: [
      {
        name: 'Código',
        id: 'fornecedor-codigo-id',
        show: true
      },
      {
        name: 'Nome',
        id: 'fornecedor-nome-id',
        show: true
      }
    ]
  },
  {
    group: 'Tipo de Suprimento',
    columns: [
      {
        name: 'Tipo de Suprimento',
        id: 'tipo-suprimento-id',
        show: true
      }
    ]
  },
  {
    group: 'Estoque',
    columns: [
      {
        name: 'Disponivel',
        id: 'ruptura-disponivel-id',
        show: true
      },
      {
        name: 'Trânsito',
        id: 'ruptura-transito-id',
        show: true
      },
      {
        name: 'Dep. 16',
        id: 'ruptura-dep-id',
        show: true
      },
      {
        name: 'Estoq CD',
        id: 'ruptura-est-cd',
        show: true
      },
      {
        name: 'Estoq Disp Buffer',
        id: 'ruptura-disp-buffer',
        show: true
      },
      {
        name: 'VM Retira Centro (4M) ',
        id: 'ruptura-ten-day-venda-media',
        show: true
      },
      {
        name: 'Custo R$',
        id: 'ruptura-ten-day-custo',
        show: true
      },

      {
        name: '0 Dias',
        id: 'ruptura-one-day-id',
        show: true
      },
      {
        name: '10 Dias',
        id: 'ruptura-ten-days-id',
        show: true
      },

      {
        name: 'Cobertura Atual',
        id: 'ruptura-dias-com-estoque',
        show: true
      }
    ]
  }
]
